import React from 'react'
import { Center, VStack } from '@chakra-ui/react'
import type { CenterProps, StackProps } from '@chakra-ui/react'

type Options = {
  innerProps?: StackProps
  backgroundProps?: CenterProps
}

// eslint-disable-next-line react/display-name
export const withCenteredBackground = ({
  backgroundProps = {}, innerProps = {}
}: Options = {}) => (Story: any) => {
  return (
    <Center
      data-testid={'centered-background'}
      background={'#a5dafa'}
      w={'calc(100vw - 40px)'}
      h={'100vh'}
      px={'20px'}
      {...backgroundProps}
    >
      <VStack
        data-testid={'centered-inner'}
        w={'100%'}
        spacing={'60px'}
        justify={'center'}
        {...innerProps}
      >
        {Story()}
      </VStack>
    </Center>
  )
}
